// Constants
import { KYC_BIZUM_SOCKET_MESSAGE } from './constants/kyc-bizum-socket.constants';
// Handlers
import { WebsocketTimeoutHandlers } from 'handlers/websocket.timeout.handlers';
// Types
import {
  KycBizumSocketBuilderHandlersType,
  KycBizumSocketConnectBuilderHandlersType,
  KycBizumSocketMethodsHandlersType,
  KycBizumSocketSendBuilderHandlersType,
} from './types/kyc-bizum-socket.handlers.type';

const startWhenSocketEventHandler = ({
  handleDisconnectWebSocketFromChannelEvent,
  handleConnectWebSocketChannelEvent,
  onError,
  onReceiveData,
  setError,
  timeoutRef,
}: KycBizumSocketConnectBuilderHandlersType): (() => void) => {
  handleConnectWebSocketChannelEvent({ onError, onReceiveData });
  const { handleStartWsTimeout, handleFinalizeWs } = WebsocketTimeoutHandlers({
    handleDisconnectWebSocketFromChannelEvent,
    setError,
    timeoutRef,
  });
  timeoutRef.current = handleStartWsTimeout();
  return () => {
    handleFinalizeWs();
  };
};

const sendMessageWhenWebSockedLoadedEventHandler = ({
  handleSendWebSocketMessageEvent,
  websocketConnected,
}: KycBizumSocketSendBuilderHandlersType): void => {
  websocketConnected && handleSendWebSocketMessageEvent({ ...KYC_BIZUM_SOCKET_MESSAGE });
};

const KycBizumSocketHandlers = ({
  handleSendWebSocketMessageEvent,
  handleDisconnectWebSocketFromChannelEvent,
  handleConnectWebSocketChannelEvent,
  websocketConnected,
  setError,
  timeoutRef,
  onError,
  onReceiveData,
}: KycBizumSocketBuilderHandlersType): KycBizumSocketMethodsHandlersType => ({
  handleSendMessageWhenWebSockedLoadedEvent: () =>
    sendMessageWhenWebSockedLoadedEventHandler({
      handleSendWebSocketMessageEvent,
      websocketConnected,
    }),
  handleStartWhenSockedLoadedEvent: () =>
    startWhenSocketEventHandler({
      handleDisconnectWebSocketFromChannelEvent,
      handleConnectWebSocketChannelEvent,
      onError,
      onReceiveData,
      setError,
      timeoutRef,
    }),
});

export { KycBizumSocketHandlers };
